import source from './selectedBarSource.generated.json';

// Only schema-defined values can become inline CSS. Markup and CSS are generated
// directly from the extension, rather than maintained as a second design.
export function selectedBarPreview(values: Record<string, unknown> = {}) {
    const settings: Record<string, string | number | boolean> = {};
    for (const field of source.fields as Array<{id:string;type:string;default?:string|number|boolean;min?:number;max?:number;options?:Array<{value:string}>}>) {
        const value = values[field.id];
        const valid = field.type === 'color' ? typeof value === 'string' && /^#[\da-f]{6}(?:[\da-f]{2})?$/i.test(value)
            : field.type === 'range' ? typeof value === 'number' && Number.isFinite(value) && value >= field.min! && value <= field.max!
            : field.type === 'checkbox' ? typeof value === 'boolean'
            : field.type === 'select' ? field.options?.some(option => option.value === value) : false;
        if (valid) settings[field.id] = value as string | number | boolean;
        else if (field.default !== undefined && field.type !== 'font_picker') settings[field.id] = field.default;
    }
    const styles = source.bindings.filter(binding => settings[binding.key] !== undefined
        && (!binding.property.startsWith('--gv-search-font-') || settings['gv-enable-custom-font-settings']))
        .map(binding => `${binding.property}:${settings[binding.key]}${binding.suffix}`);
    const background = settings['gv-selected-use-gradient']
        ? `linear-gradient(360deg, ${settings['gv-toggle-button-bg']} 0%, ${settings['gv-selected-gradient-end']} 100%)`
        : String(settings['gv-toggle-button-bg']);
    styles.push(`--gv-selected-background:${background}`, `--gv-toggle-button-background:${background}`);
    const fullWidth = settings['gv-disable-full-width-class'];
    return {
        css: source.css,
        markup: `<div id="gv-mmy-bar-preview" data-gv-shop="preview.myshopify.com" class="gv-mmy-bar gv-mmy-bar--modern gv-modern-has-vehicle${fullWidth ? ' gv-mmy-bar--full-width' : ''}" style="${styles.join(';')}"><div class="${fullWidth ? '' : 'page-width '}wrapper container">${source.markup}</div></div>`,
        responsive: settings['gv-show-toggle-button'] === true,
    };
}
